import { type LegacyApiError, useApi } from '@omnipresentgroup/api';
import { HTTPStatusCodes } from '@omnipresentgroup/constants';
import type {
  GetTimesheetsResponse,
  TimesheetArbeitszeit,
} from '@omnipresentgroup/types';
import { useQuery } from '@tanstack/react-query';

import { API_BASE, API_PATH } from '../constants';

export const useGetTimesheets = ({
  employeeId,
  enabled,
}: {
  employeeId: string;
  enabled?: boolean;
}) => {
  const { GET } = useApi();

  return useQuery<
    GetTimesheetsResponse,
    LegacyApiError,
    TimesheetArbeitszeit[]
  >({
    queryKey: [API_PATH, employeeId],
    queryFn: () =>
      GET<GetTimesheetsResponse>(
        `${API_BASE}/${API_PATH}/employees/${employeeId}`,
        {},
      ),
    throwOnError: (error) => error.status !== HTTPStatusCodes.NOT_FOUND,
    enabled,
  });
};
